import { Box } from '@mui/material';
import { FilterChip } from 'src/components/atoms/filter-chip';
import { FilterValue } from 'src/hooks/meilisearch/types/filter-value';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { Filters } from 'src/types/interfaces/filters';

export interface FilterType {
  value: string;
  text: (value: FilterValue) => string;
}

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  filterTypes: FilterType[];
}

export const FilterChips = ({
  filters,
  handleChangeFilterValue,
  filterTypes,
}: Props) => {
  const getFilterDisplayText = (
    filterType: string,
    value: FilterValue,
  ): string => {
    const filterConfig = filterTypes.find(type => type.value === filterType);

    if (!filterConfig) return value.toString();

    return filterConfig.text(value);
  };

  const renderFilterChips = () =>
    Object.entries(filters)?.map(
      ([filterType, { value: filterValues, operator }]) => {
        if (!filterValues) {
          return null;
        }

        if (Array.isArray(filterValues)) {
          if (operator === 'timerange') {
            return (
              <FilterChip
                key={`${filterType}-${filterValues.toString()}`}
                filterValue={filterValues}
                filterType={filterType}
                filterOperator={operator}
                filters={filters}
                handleChangeFilterValue={handleChangeFilterValue}
                text={getFilterDisplayText(filterType, filterValues)}
              />
            );
          }

          return filterValues?.map(value => (
            <FilterChip
              key={`${filterType}-${value.toString()}`}
              filterValue={value as string}
              filterType={filterType}
              filterOperator={operator}
              filters={filters}
              handleChangeFilterValue={handleChangeFilterValue}
              text={getFilterDisplayText(filterType, value)}
            />
          ));
        }

        return null;
      },
    );

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyItems: 'flex-start',
        flexWrap: 'wrap',
        px: 3,
        pb: 1.5,
      }}>
      {renderFilterChips()}
    </Box>
  );
};
